import { PropsWithChildren } from 'react';
import { DurationVitalGate, DurationVitalProvider, ReportDurationVital } from './durationVital';

export const MFE_FIRST_PAINT_VITAL = 'mfe.first_paint';

interface MfeFirstPaintProviderProps extends PropsWithChildren {
    mfeName: string;
}

export const MfeFirstPaintProvider = ({ mfeName, children }: MfeFirstPaintProviderProps) => (
    <DurationVitalProvider vitalName={MFE_FIRST_PAINT_VITAL} context={{ mfe: mfeName }}>
        {children}
    </DurationVitalProvider>
);

export const ReportMfeFirstPaint = ReportDurationVital;

/** Place after loading/setup gates so the vital excludes interim null/loader states. */
export const MfeFirstPaintGate = ({ children }: PropsWithChildren) => (
    <DurationVitalGate>{children}</DurationVitalGate>
);
